(function () {
  // Fitreno canlı ziyaretçi beacon'u — ctatement paneli canlı haritası için.
  // Çerez/kişisel veri yok; anonim localStorage oturum id'si + sayfa yolu + aşama.
  var ENDPOINT = 'https://fitreno.shop/live.php';
  var KEY = '3afa106151a40ae1';
  var SHOP = 'ju0sfm-ms.myshopify.com';
  var BEAT_MS = 15000;
  var IDLE_MS = 30 * 60 * 1000;

  function cid() {
    try {
      var k = 'fr_live_c', v = localStorage.getItem(k);
      if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return 's' + Math.random().toString(36).slice(2, 10); }
  }
  var C = cid();
  var lastEventAt = Date.now();

  function stageFromPath(path) {
    var p = String(path || '').toLowerCase();
    if (/^\/checkouts?\//.test(p)) return /thank[-_]?you/.test(p) ? 'thankyou' : 'checkout';
    if (/^\/(\d+\/)?orders\//.test(p)) return 'thankyou';
    if (/^\/cart(\/|$)/.test(p)) return 'cart';
    return 'browse';
  }
  function isHidden() { return document.visibilityState === 'hidden'; }

  function send() {
    if (isHidden()) return;
    if (Date.now() - lastEventAt > IDLE_MS) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST', mode: 'no-cors', keepalive: true, credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          s: SHOP, k: KEY, c: C,
          p: String(location.pathname).slice(0, 255),
          st: stageFromPath(location.pathname),
          r: String(document.referrer || '').slice(0, 255)
        })
      }).catch(function () {});
    } catch (e) {}
  }

  send();
  setInterval(send, BEAT_MS);
  document.addEventListener('visibilitychange', function () { if (!isHidden()) send(); });
})();
